import { render } from "./NoticeWrite.vue?vue&type=template&id=61d33e5c"
import script from "./NoticeWrite.vue?vue&type=script&lang=js"
export * from "./NoticeWrite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__